import React from 'react';
import { Container, Grid, Typography } from '@material-ui/core';
import ActionButton from '../../Components/ActionButton/ActionButton';
import MultiLine from '../../Components/MultiLine';
import { useStyle } from './useStyle';

const NotFound = () => {
	const style = useStyle();
	return (
		<div className={style.root}>
			<Container className={style.container}>
				<Grid alignItems='center' container>
					<Grid item xs={12} md={6}>
						<Typography className={style.header} variant='h1'>
							404
						</Typography>
						<div className={style.content}>
							<MultiLine
								text={`sorry! this page does not exist any more.
									you can continue your survey from home.`}
							/>
						</div>
						<div style={{ marginTop: '24px' }}>
							<ActionButton text='Go Home' link='/home' />
						</div>
					</Grid>
				</Grid>
			</Container>
		</div>
	);
};

export default NotFound;
